import React from "react"
import { twJoin } from "tailwind-merge"
import Image from "next/image"
import g2 from "@images/home-trust/g2.webp"
import softwareAdvice from "@images/home-trust/software-advice.webp"
import crozDesk from "@images/home-trust/crozdesk.webp"
import trustPilot from "@images/home-trust/trustpilot.webp"
import capterra from "@images/home-trust/capterra.webp"
import trustRadius from "@images/home-trust/trust-radius.webp"
import getApp from "@images/home-trust/get-app.webp"

export const TrustBanners = () => (
  <div
    className={twJoin(
      "flex flex-row justify-around w-full mx-auto",
      "flex-wrap",
      "gap-24p",
      "768:gap-32p",
      "768:max-w-[736px]",
      "1440:justify-between",
      "1440:max-w-[1280px]"
    )}
  >
    <a href="https://www.g2.com/products/traqq/reviews">
      <Image
        className={twJoin("h-auto w-full", "max-w-[108px]  ", "480:max-w-[160px]", " 1440:max-w-[140px]")}
        src={g2}
        alt="4.5, G2.com"
        width={280}
        height={96}
        unoptimized
      />
    </a>
    <a href="https://www.softwareadvice.com/project-management/traqq-profile">
      <Image
        className={twJoin("h-auto w-full", "max-w-[108px]  ", "480:max-w-[160px]", " 1440:max-w-[140px]")}
        src={softwareAdvice}
        alt="5, Software Advice"
        width={280}
        height={96}
        unoptimized
      />
    </a>
    <a href="https://crozdesk.com/software/traqq">
      <Image
        className={twJoin("h-auto w-full", "max-w-[108px]  ", "480:max-w-[160px]", " 1440:max-w-[140px]")}
        src={crozDesk}
        alt="92/100, Crozdesk"
        width={280}
        height={96}
        unoptimized
      />
    </a>
    <a href="https://www.trustpilot.com/review/traqq.com">
      <Image
        className={twJoin("h-auto w-full", "max-w-[108px]  ", "480:max-w-[160px]", " 1440:max-w-[140px]")}
        src={trustPilot}
        alt="4.5, Trustpilot"
        width={280}
        height={96}
        unoptimized
      />
    </a>
    <a href="https://www.capterra.com/p/230726/Traqq">
      <Image
        className={twJoin("h-auto w-full", "max-w-[108px]  ", "480:max-w-[160px]", " 1440:max-w-[140px]")}
        src={capterra}
        alt="5, Capterra"
        width={280}
        height={96}
        unoptimized
      />
    </a>
    <a href="https://www.trustradius.com/products/traqq/reviews">
      <Image
        className={twJoin("h-auto w-full", "max-w-[108px]  ", "480:max-w-[160px]", " 1440:max-w-[140px]")}
        src={trustRadius}
        alt="9.5, Trust Radius"
        width={280}
        height={96}
        unoptimized
      />
    </a>
    <a href="https://www.getapp.com/project-management-planning-software/a/traqq">
      <Image
        className={twJoin("h-auto w-full", "max-w-[108px]  ", "480:max-w-[160px]", " 1440:max-w-[140px]")}
        src={getApp}
        alt="5, Get App"
        width={280}
        height={96}
        unoptimized
      />
    </a>
  </div>
)
